import Vue from 'vue';

Vue.component('promo-header', {
    mounted() {
        const header = document.querySelector('#promo-title');
        if (!header.dataset.colorStyle) return;

        header.style.color = header.dataset.colorStyle;
    },
});
